import { render } from "./SubmitDevoir.vue?vue&type=template&id=1f1ba42d&scoped=true&ts=true"
import script from "./SubmitDevoir.vue?vue&type=script&lang=ts"
export * from "./SubmitDevoir.vue?vue&type=script&lang=ts"

import "./SubmitDevoir.vue?vue&type=style&index=0&id=1f1ba42d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1ba42d"]])

export default __exports__